import L from 'leaflet'
import markerIcon2xUrl from 'leaflet/dist/images/marker-icon-2x.png'
import markerIconUrl from 'leaflet/dist/images/marker-icon.png'
import markerShadowUrl from 'leaflet/dist/images/marker-shadow.png'
import { iconNameToEmoji } from './constants'

// Create custom icons
export const createIcon = (iconUrl: string, shadowUrl: string, iconSize: [number, number] = [25, 41], shadowSize: [number, number] = [41, 41]) => {
  return L.icon({
    iconUrl,
    shadowUrl,
    iconSize,
    shadowSize,
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowAnchor: [4, 62]
  })
}

// Set default icons
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2xUrl,
  iconUrl: markerIconUrl,
  shadowUrl: markerShadowUrl,
  iconSize: [25, 41],
  shadowSize: [41, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowAnchor: [4, 62]
})

// Create user location icon (blue)
export const userLocationIcon = createIcon(markerIconUrl, markerShadowUrl, [25, 41], [41, 41])
userLocationIcon.options.className = 'user-location-marker'

// Create custom category marker icon (bigger size)
export const createCategoryMarkerIcon = (category: any) => {
  const color = category?.color || '#3B82F6'
  const iconUrl = category?.icon_url || null
  const iconName = category?.icon || '📍'

  // Check if iconUrl is a valid URL (starts with http or /)
  const isValidUrl = iconUrl && typeof iconUrl === 'string' && (iconUrl.startsWith('http') || iconUrl.startsWith('/'))

  // Get emoji from icon name if it's not a URL
  const emoji = isValidUrl ? null : (iconNameToEmoji[iconName.toLowerCase()] || iconName || '📍')

  // Bigger marker dimensions
  const size = 44 // px
  const imgSize = 24 // px
  const anchor = Math.round(size / 2)

  // Create HTML for custom marker
  const html = `
    <div style="
      position: relative;
      width: ${size}px;
      height: ${size}px;
      background-color: ${color};
      border-radius: 50% 50% 50% 0;
      transform: rotate(-45deg);
      border: 2px solid white;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      display: flex;
      align-items: center;
      justify-content: center;
    ">
      <div style="
        transform: rotate(45deg);
        color: white;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      ">
        ${isValidUrl ? `<img src="${iconUrl}" style="width: ${imgSize}px; height: ${imgSize}px; object-fit: contain;" onerror="this.style.display='none'; this.parentElement.innerHTML='${emoji}'" />` : emoji}
      </div>
    </div>
    <div style="
      position: absolute;
      bottom: -6px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 10px solid ${color};
    "></div>
  `

  return L.divIcon({
    html,
    className: 'custom-category-marker',
    iconSize: [size, size],
    iconAnchor: [anchor, size],
    popupAnchor: [0, -size],
  })
}

